import styles from './progressbar.module.scss';

interface ProgressBarProps {
  value: number;
}

export default function ProgressBar({ value }: ProgressBarProps) {
  return (
    <div className={`w-100 border ${styles.outer}`}>
      <div style={{ width: `${value}%` }} className={styles.inner} />
    </div>
  );
}
